/* eslint-disable camelcase */
import { loadScript } from "../load-script";
import log from "common/log";

function getClientId (env = "") {
  const devId =
    "555375249032-bj3lgs1t9mjdhalhu3i0dq51hn6hdopl.apps.googleusercontent.com";
  return {
    prod:
      "631169689843-jsfa280p2vr6hv0ilptpood4s8tsi3v6.apps.googleusercontent.com",
    staging:
      "935807371193-87acgtpfomgo4lmf6p662ls21jet0q5a.apps.googleusercontent.com",
    dev: devId,
    desktop: devId
  }[env.toLowerCase() || "dev"];
}

function loadAuth2 (gapi) {
  return new Promise((resolve) => {
    gapi.load("auth2", () => {
      resolve(gapi.auth2);
    });
  });
}

export function initialiseGoogleAuth () {
  return loadScript("https://apis.google.com/js/platform.js")
    .then(() => {
      return loadAuth2(window.gapi);
    })
    .then((auth2) => {
      return auth2.init({
        client_id: getClientId(window.wahanda.pageConfig.environment),
        cookie_policy: "single_host_origin",
        fetch_basic_profile: true
      });
    })
    .catch((err) => {
      log.client(log.INFO, err);
      const error = err.error ? `${err.error} ${err.details}` : err;
      throw error;
    });
}

export function getGoogleAuthCode () {
  const authInstance = window.gapi.auth2.getAuthInstance();

  return authInstance
    .signIn({
      prompt: "select_account"
    })
    .then((googleUser) => googleUser.getAuthResponse().id_token)
    .catch((err) => {
      log.client(log.INFO, err);
      const error = err.error ? err.error : err;
      throw error;
    });
}
